import FlexPane from './_flex-pane.js'
import ConfigurableFlex from './_configurable-flex.js'
import FlexContainerBase from './_flex-container-base.js'
import ConfigurableFlexItem from './_configurable-flex-item.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableSize from './_configurable-size.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import SwiperNavigationButton from './_swiper-navigation-button.js'
import SwiperSlide from './_swiper-slide.js'

export default {
  name: 'Swiper',
  values: {
    class: 'swiper',
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexBasis: '100%',
          maxWidth: '100%',
        },
      },
    },
    style: {
      _mobile_overflow: 'auto hidden',
      overflow: 'hidden',
      maxWidth: '100%',
      scrollSnapType: 'x mandatory',
      scrollPaddingLeft: undefined,
      scrollPaddingRight: undefined,
      $mixin: [
        {
          configSet: ConfigurableFlex,
        },
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: ConfigurableFlexItem,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurablePosition,
        },
        {
          configSet: ConfigurablePadding,
        },
        {
          configSet: ConfigurableSize,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
      ],
    },
    loop: false,
    autoPlay: false,
    autoPlayInterval: 7000,
    disableAutoPlayOnInteraction: true,
    centerViewableSlide: false,
    enableNavigation: true,
    _mobile_enableNavigation: false,
    lazyLoadBufferSize: -1,
    minViewableBufferSize: -1,
    scrollBehavior: 'smooth',
    forwardNavigation: {
      configSet: SwiperNavigationButton,
      configValues: {
        container: {
          style: {
            right: 0,
          },
        },
        button: {
          buttonIcon: {
            src: 'arrow-right',
          },
        },
      },
    },
    backwardNavigation: {
      configSet: SwiperNavigationButton,
      configValues: {
        button: {
          buttonIcon: {
            src: 'arrow-left',
          },
        },
      },
    },
    slide: {
      configSet: SwiperSlide,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
